import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import "../Director/ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function ApcApplications() {
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;



  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    fetch(
      `${API_BASE_URL}/getShortlistedAPCApplicationsbyUser/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Data:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));
  }, [userId]);

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Shortlisted APC Applications</h1>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Upload Payment Receipt</th>
            <th>View Payment Receipt</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((app) => (
            <tr key={app.Application_Id}>
              <td>{app.Application_Id}</td>
              <td>{app.Award_Type}</td>
              <td>{app.SubmittedDate}</td>
              <td>{app.Status}</td>

              {/* Upload Payment Receipt */}
              <td>
                {app.Payment_Receipt_Receive === 1 ? (
                  <button
                    className="View_Button"
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "none",
                    }}
                    disabled
                  >
                    Uploaded
                  </button>
                ) : (
                  <>
                    <input
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setApplications((prev) =>
                          prev.map((item) =>
                            item.Application_Id === app.Application_Id
                              ? { ...item, selectedFile: file }
                              : item
                          )
                        );
                      }}
                    />
                    <button
                      className="View_Button"
                      style={{ marginTop: "5px" }}
                      onClick={() => {
                        const selectedFile = app.selectedFile;
                        if (!selectedFile) {
                          alert("Please select a file first.");
                          return;
                        }

                        const formData = new FormData();
                        formData.append("file", selectedFile);
                        formData.append("applicationId", app.Application_Id);

                        fetch(
                          `${API_BASE_URL}/uploadAPCPaymentForm`,
                          {
                            method: "POST",
                            body: formData,
                          }
                        )
                          .then((res) => res.json())
                          .then((data) => {
                            alert("Upload successful!");
                            setApplications((prev) =>
                              prev.map((item) =>
                                item.Application_Id === app.Application_Id
                                  ? { ...item, Payment_Receipt_Receive: 1 }
                                  : item
                              )
                            );
                          })
                          .catch((err) => {
                            console.error("Upload failed:", err);
                            alert("Upload failed");
                          });
                      }}
                    >
                      Upload
                    </button>
                  </>
                )}
              </td>
              {/* Payment Request Form - Download only */}
              <td>
                {app.Payment_Receipt_Receive === 1 ? (
                  <button
                    className="View_Button"
                    onClick={() => {
                      const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/APCPaymentReceipt/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    Download
                  </button>
                ) : (
                  <span style={{ color: "gray" }}>Not available</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
